module.exports = __webpack_public_path__ + "static/dunning-retention-header-0d0588ad5fa04de854baa832e93a023f.svg";